<template>
  <div class="position-relative">
    <overlay ref="errorAlert" blocking>
      <div class="text-center">
        <h4>{{ $t("error.api_error_headline") }}</h4>
        <div>{{ $t("error.api_error_body") }}</div>
      </div>
    </overlay>
    <overlay ref="changedAlert" blocking>
      <div class="text-center">
        <h4>{{ $t("hinweis_titel") }}</h4>
        <div v-if="kostenuebernahme">
          <p>
            {{
              $tc("hinweis_text", 1, {
                kostenuebernahme: kostenuebernahme[$i18n.locale],
              })
            }}
          </p>
        </div>
        <div v-else>
          <p>
            {{ $t("hinweis_keine_behandlung") }}
          </p>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <button
              class="btn btn-outline-secondary btn-block"
              @click="
                $store.dispatch('terminbuchungAbbrechen');
                $refs.changedAlert.hide();
              "
            >
              {{ $t("actions.abbrechen") }}
            </button>
          </div>
          <div class="col-md-6 mt-3 mt-md-0">
            <button
              class="btn btn-primary btn-block"
              @click="$refs.changedAlert.hide()"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </overlay>
    <div class="container pt-0 px-0">
      <!--
      <div class="row">
        <div
          class="col d-none d-md-block text-center"
        >
          <h1
            class="text-center fs-40 primary-headline"
            :style="{ 'font-weight': 900 }"
          >
            {{ $t("heading_booking") }}
          </h1>
        </div>
        <div class="col d-md-none">
          <h2>{{ $t("heading_booking") }}</h2>
        </div>
      </div>-->

      <div class="row justify-content-md-center">
        <div class="col-md-4">
          <div class="alert alert-warning">
            <b>Bestandspatienten</b> verwenden bitte die Online-Buchung unter
            unter clinius.de oder h1-zahnaerzte.ch
          </div>
        </div>
      </div>

      <div class="row justify-content-md-center" v-if="!selectedTermin">
        <div class="col-md-4">
          <div class="mb-15">
            <h3>{{ $t("head_relationship") }}</h3>
            <button-switch
              class="btn-switcher"
              :values="[
                /* { title: $t('btn_existing'), value: true }, */
                { title: $t('btn_new'), value: false },
              ]"
              :reduce="(e) => e.value"
              :disabled="$store.state.patient.patient_hash !== null"
              v-model="bestandspatient"
            >
            </button-switch>
          </div>

          <div v-if="bestandspatient !== null">
            <div class="mb-3">
              <h3>{{ $t("kostenuebernahme") }}</h3>
              <versicherungsart-tree
                @kostenuebernahme_changed="$refs.changedAlert.show()"
                :options="kostenuebernahmen"
                v-model="kostenuebernahme"
              />
            </div>
            <h3>{{ $t("head_request") }}</h3>

            <v-select
              v-if="kostenuebernahme"
              :options="gruppierteBehandlungsarten"
              v-model="behandlungsart"
              label="key"
              :clearable="false"
              :searchable="false"
              :disabled="festeTerminart"
              class="mb-3"
              :class="{ 'hide-search': behandlungsart }"
              :placeholder="$t('behandlungswunsch_placeholder')"
            >
              <template slot="option" slot-scope="option">
                {{ option.bezeichnung[$i18n.locale] || option.titel }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.bezeichnung[$i18n.locale] || option.titel }}
              </template>
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes" class="text"
                  ><font-awesome-icon icon="sort-down"
                /></span>
              </template>
            </v-select>

            <div
              v-if="behandlung"
              class="pane small-pane text-left"
              style="margin-top: 5px"
            >
              <div class="row">
                <div class="col-6">
                  <font-awesome-icon icon="clock" /> {{ $t("circa") }}
                  {{ behandlung.dauer }} min
                </div>
                <div class="col-6">
                  <font-awesome-icon icon="wallet" />
                  {{
                    (typeof behandlung.preis === "string"
                      ? behandlung.preis
                      : behandlung.preis[$i18n.locale]) | preis
                  }}
                </div>
              </div>
              <br />

              <div class="line-breaks">
                {{ behandlung.beschreibung[$i18n.locale] }}
              </div>
            </div>
          </div>

          <div v-if="behandlungBlock" class="alert alert-warning">
            {{ behandlungBlock }}
          </div>
        </div>

        <div class="cc-info" v-if="kostenuebernahme && !showCalendar">
          <div class="row">
            <div
              class="col"
              :key="item.key"
              v-for="item in gruppierteBehandlungsarten"
              style="align-self: end"
            >
              <div :key="element.id" v-for="element in item.elements">
                <div
                  class="pane small-pane"
                  v-if="element.versicherungsart == kostenuebernahme.id"
                  style="font-size: 80%; line-height: 1.1"
                >
                  <b>{{
                    element.bezeichnung[$i18n.locale] || element.bezeichnung
                  }}</b
                  ><br />
                  <br />
                  <div
                    class="line-breaks"
                    v-html="element.beschreibung[$i18n.locale]"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <transition name="calendar">
          <div v-if="showCalendar" class="col-md-8 calendar">
            <overlay ref="naechsterTerminAlert">
              <div class="text-center">
                <div class="font-weight-bold fs-14 mb-3" v-if="$t('error.kein_termin_in_woche')">
                  {{ $t("error.kein_termin_in_woche") }}
                </div>
                <button
                  class="btn btn-primary"
                  @click="
                    startDate = nextTermin;
                    ladeTermine();
                  "
                >
                  {{ $t("naechster_termin") }}
                  {{ nextTermin | dateShort }}
                  <font-awesome-icon icon="arrow-right" />
                </button>
              </div>
            </overlay>
            <overlay ref="keinTerminAlert">
              <div class="text-center">
                <div class="font-weight-bold fs-14 mb-3">
                  {{ $t("error.kein_termin_gefunden") }}
                </div>
              </div>
            </overlay>
            <div class="row">
              <h3 class="col-auto">{{ $t("head_planner") }}</h3>
              <div class="col-auto ml-auto fs-12" v-if="hasPreferredTermine">
                <font-awesome-icon icon="star" style="color: gold" /> =
                {{ $t("empfohlene_termine") }}
              </div>
            </div>
            <div
              class="pane pl-0 pr-0 pl-md-3 pr-md-3 h-auto"
              :class="{ 'bg-white': isMobile }"
            >
              <calendar
                v-if="!selectedDay && !selectedRow"
                :anzahlTage="anzahlTage"
                @dateChanged="ladeTermine()"
              />
              <!--<div
                v-if="
                  selectedDay != null && selectedRow != null && !selectedTermin
                "
              >
                <terminauswahl />
              </div>-->
            </div>
            <div
              v-if="showCalendar"
              class="mt-3 d-flex justify-content-between"
            >
              <button
                class="btn btn-outline-secondary"
                @click="$store.dispatch('terminbuchungAbbrechen')"
              >
                {{ $t("actions.abbrechen") }}
              </button>
            </div>
          </div>
        </transition>
      </div>
      <patientendaten
        v-else
        @buchen="(forceEmail) => sendBooking(forceEmail)"
        ref="patientendaten"
        is-otp-page
      />
    </div>
  </div>
</template>

<script>
import ButtonSwitch from "../components/ButtonSwitch.vue";
//import Terminauswahl from "../components/Terminauswahl.vue";
import Patientendaten from "../components/Patientendaten.vue";
import VersicherungsartTree from "../components/VersicherungsartTree.vue";
import Calendar from "../components/Calendar.vue";

import { Api } from "@/api/";

import _ from "lodash";
import { DateTime, Interval } from "luxon";
import {
  SET_BESTANDSPATIENT,
  SET_BEHANDLUNG,
  SET_PRAXIS,
  SET_BEHANDLER,
  SET_SELECTED_DAY,
  SET_SELECTED_ROW,
  SET_KOSTENUEBERNAHME,
  SET_BEHANDLUNGSART,
  SET_START_DATE,
} from "@/store/mutations.type";
import { SET_BOOKED_AT, SET_KOSTENUEBERNAHME_FINAL, SET_PAGE } from "../store/mutations.type";

// @ is an alias to /src
//import Start from "@/components/Start.vue";

export default {
  name: "OTP Callcenter",
  components: {
    ButtonSwitch,
    //Terminauswahl,
    Patientendaten,
    VersicherungsartTree,
    Calendar,
  },
  data() {
    return {
      festeTerminart: false,
      nextTermin: null,
    };
  },
  watch: {
    showCalendar(isShown) {
      if (isShown && !this.praxis && !this.behandler) {
        this.ladeTermine();
      }
    },
    bestandspatient() {
      if (navigator.bx_terminart) {
        //this.festeTerminart = true;

        this.behandlungsart = this.gruppierteBehandlungsarten.find((ba) => {
          return _.some(
            ba.elements,
            (ta) => ta.id === navigator.bx_terminart
          );
        });
      }
    },
    behandlung() {
      this.ladeTermine();
    },
    praxis() {
      this.ladeTermine();
    },
    behandler() {
      this.ladeTermine();
    },
    kostenuebernahme(val) {
      if (this.behandlungsart && val) {
        this.behandlung = this.behandlungsart.elements.find(
          (e) => e.versicherungsart === val.id
        );
      }
    },
    behandlungsart(val) {
      if (this.kostenuebernahme && val) {
        this.behandlung = val.elements.find(
          (e) => e.versicherungsart === this.kostenuebernahme.id
        );
      }
      //this.ladeTermine();
    },
  },
  computed: {
    /**
     * Anzahl der Angezeigten Tage im Kalender
     */
    anzahlTage() {
      return this.isMobile ? 4 : 7;
    },
    praxen() {
      return this.$store.state.praxen;
    },
    kostenuebernahmen() {
      return this.$store.state.kostenuebernahmen;
    },
    termine() {
      return this.$store.state.termine;
    },
    hasPreferredTermine() {
      return typeof this.termine.find((t) => t.preferred) !== "undefined";
    },
    behandlungBlock() {
      try {
        if (!this.behandlung || this.bestandspatient === null)
          return false;
        return this.behandlung.block[
          this.bestandspatient ? "bestandspatient" : "neupatient"
        ][this.$i18n.locale];
      } catch {
        return false;
      }
    },
    bestandspatient: {
      get() {
        return false;
        //return this.$store.state.patient.bestandspatient;
      },
      set(val) {
        this.$store.dispatch("terminbuchungAbbrechen");
        this.$store.commit(`patient/${SET_BESTANDSPATIENT}`, val);
      },
    },
    behandlung: {
      get() {
        return this.$store.state.termin.behandlung;
      },
      set(val) {
        this.behandler = null;
        this.$store.commit(`termin/${SET_BEHANDLUNG}`, val);
      },
    },
    startDate: {
      get() {
        return this.$store.state.startDate;
      },
      set(val) {
        this.$store.commit(`${SET_START_DATE}`, val);
      },
    },
    behandlungsart: {
      get() {
        return this.$store.state.termin.behandlungsart;
      },
      set(val) {
        this.$store.commit(`termin/${SET_BEHANDLUNGSART}`, val);
      },
    },
    praxis: {
      get() {
        return this.$store.state.termin.praxis;
      },
      set(val) {
        this.$store.commit(`termin/${SET_PRAXIS}`, val);
      },
    },
    behandler: {
      get() {
        return this.$store.state.termin.behandler;
      },
      set(val) {
        this.$store.commit(`termin/${SET_BEHANDLER}`, val);
      },
    },
    kostenuebernahme: {
      get() {
        return this.$store.state.termin.kostenuebernahme;
      },
      set(val) {
        this.$store.commit(`termin/${SET_KOSTENUEBERNAHME}`, val);
      },
    },
    selectedDay: {
      get() {
        return this.$store.state.termin.selectedDay;
      },
      set(val) {
        this.$store.commit(`termin/${SET_SELECTED_DAY}`, val);
      },
    },
    selectedRow: {
      get() {
        return this.$store.state.termin.selectedRow;
      },
      set(val) {
        this.$store.commit(`termin/${SET_SELECTED_ROW}`, val);
      },
    },
    selectedTermin: {
      get() {
        return this.$store.state.termin.selectedTermin;
      },
    },
    benachrichtigungen() {
      return this.$store.state.patient.benachrichtigungen;
    },
    showCalendar() {
      return (
        !this.behandlungBlock &&
        this.bestandspatient !== null &&
        this.behandlung &&
        this.kostenuebernahme &&
        this.startDate != null
      );
    },
    therapists() {
      // TODO prüfen, ob wir hier lieber leer zurückschicken?
      if (!this.behandlung) return this.$store.state.behandlerlist;
      let bhid = this.behandlung.id;
      return this.$store.state.behandlerlist
        .filter((b) => {
          return (
            b.terminarten.indexOf(bhid) >= 0
          );
        })
        .sort((a, b) => {
          return b.prio - a.prio;
        });
    },
    behandlungsarten() {
      var bp = this.bestandspatient;
      return this.$store.state.behandlungsarten.filter((b) => {
        return (
          (bp == false && b.neupatienten) || (bp == true && b.bestandspatienten)
        );
      });
    },
    gruppierteBehandlungsarten() {
      let grouped = _.chain(this.behandlungsarten)
        .groupBy((b) => b.titel)
        .value();
      return Object.keys(grouped).map((k) => {
        let elements = grouped[k];
        let first = _.head(elements);
        return {
          key: k,
          bezeichnung: first.bezeichnung,
          beschreibung: first.beschreibung,
          elements: elements,
          dauer: first.dauer,
          preis: first.preis,
        };
      });
    },
  },
  async created() {
    try {
      await this.$store.dispatch("loadBehandler");
      await this.$store.dispatch("loadBehandlungsarten");

      if (this.$route.query.bestandspatient) {
        this.bestandspatient =
          JSON.parse(this.$route.query.bestandspatient) || null;

        if (this.$route.query.versicherung) {
          let kostenuebernahme =
            this.kostenuebernahmen.find(
              (e) => e.id === this.$route.query.versicherung
            ) || null;
          this.kostenuebernahme = kostenuebernahme;
          this.$store.commit(`termin/${SET_KOSTENUEBERNAHME_FINAL}`, true);
        }

        if (this.$route.query.behandlung) {
          let behandlung =
            this.behandlungsarten.find(
              (e) => e.id === this.$route.query.behandlung
            ) || null;
          this.behandlung = behandlung;

          this.$nextTick(() => {
            if (behandlung) {
              let gruppierteBehandlungsart =
                this.gruppierteBehandlungsarten.find(
                  (e) => e.key === behandlung.titel
                ) || null;
              this.behandlungsart = gruppierteBehandlungsart;
            }
          });
        }
      }
    } catch (e) {
      this.$refs.errorAlert.show();
    }
  },
  mounted() {
    // suche ersten Tag dieser Woche

    let d = new Date();
    let day = d.getDay();
    let diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    this.startDate = new Date(d.setDate(diff));
  },

  methods: {
    async ladeTermine() {
      if (
        !this.kostenuebernahme ||
        this.bestandspatient === null ||
        !this.behandlung
      )
        return;
      if (this.$refs.naechsterTerminAlert)
        this.$refs.naechsterTerminAlert.hide();
      if (this.$refs.keinTerminAlert) this.$refs.keinTerminAlert.hide();
      let cnt = await this.$store.dispatch("loadTermine", [
        this.startDate,
        this.anzahlTage,
        this.behandlung.id,
        this.praxis,
        this.behandler ? this.behandler.id : null,
      ]);
      if (cnt > 0) {
        // Termine gefunden, checke, ob die in der aktuellen Woche liegen, sonst zeige Hinweis
        let firstTermin = this.termine[0];
        let startDate = DateTime.fromISO(firstTermin.start);
        let duration = Interval.fromDateTimes(this.startDate, startDate);

        if (duration.count("days") > this.anzahlTage) {
          this.nextTermin = startDate.toJSDate();
          if (this.$refs.naechsterTerminAlert)
            this.$refs.naechsterTerminAlert.show();
        }
      } else if (cnt == 0) {
        // Keine Termine in den nächsten Wochen, zeige Hinweis
        if (this.$refs.keinTerminAlert) this.$refs.keinTerminAlert.show();
      }
    },
    async sendBooking(forceEmail = true) {
      try {
        let geburtstag = this.$store.state.patient.geburtsdatum;
        let formattedGeburtstag = "";
        if (typeof geburtstag === "string") {
          formattedGeburtstag = _.chain(this.$store.state.patient.geburtsdatum)
            .split("-")
            .reverse()
            .join(".")
            .value();
        } else if (typeof geburtstag === "object") {
          formattedGeburtstag =
            DateTime.fromJSDate(geburtstag).toFormat("dd.MM.yyyy");
        }

        let json = {
          Bestandspatient: this.$store.state.patient.bestandspatient,
          patient_hash: this.$store.state.patient.patient_hash,
          Terminart: this.behandlung.id,
          Datum: this.selectedTermin.start.toLocaleString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }),
          start: this.selectedTermin.start,
          praxis: this.praxis,
          Schicht: this.selectedTermin.shift.id,
          Anrede: this.$store.state.patient.anrede,
          Vorname: this.$store.state.patient.vorname,
          Name: this.$store.state.patient.name,
          Email: this.$store.state.patient.mailadresse,
          Strasse: this.$store.state.patient.adr_strasse,
          StrasseNr: this.$store.state.patient.adr_strassenr,
          Plz: this.$store.state.patient.adr_plz,
          Ort: this.$store.state.patient.adr_ort,
          Land: this.$store.state.patient.adr_land,
          Telefon: this.$store.state.patient.telefonnummer,
          nachruecker: this.benachrichtigungen,
          kostenuebernahme: this.kostenuebernahme.id,
          Freitext: this.$store.state.patient.freitext,
          Geburtsdatum: formattedGeburtstag,
          duration: this.selectedTermin?.duration,
          forceEmail,
          callcenter: true,
        };

        let response = await Api.post("/book/", json);

        if (response.status === 409) {
          this.$refs.patientendaten.showTerminBereitsVergeben();
        } else if (response.status === 422) {
          this.$refs.patientendaten.showEmailInvalid();
        } else {
          this.$store.commit(SET_BOOKED_AT, DateTime.now());
          this.$store.commit(SET_PAGE, "callcenter-terminbestaetigung");
        }
      } catch (e) {
        if (e.response.status === 409) {
          this.$refs.patientendaten.showTerminBereitsVergeben();
        } else if (e.response.status === 422) {
          this.$refs.patientendaten.showEmailInvalid();
        } else {
          this.$refs.errorAlert.show();
        }
      } finally {
        if (this.isMobile) {
          const el = document.getElementById(this.appId);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }
    },
  },
};
</script>


<style lang="css">
.cc-info {
  display: inline-block;
  position: fixed;
  bottom: 0;
  z-index: 0;
}
</style>
